import styled from 'styled-components';

export const StyledContentWrapper = styled.div(({ theme }) =>
  theme.withMedia({
    marginTop: '20px',
    padding: '0 20px'
  })
);

export const Title = styled.div(({ theme }) =>
  theme.withMedia({
    color: theme.colors.mainWhite,
    fontSize: '16px',
    fontWeight: '700',
    lineHeight: '28px'
  })
);

export const StyledHash = styled.div(({ theme }) =>
  theme.withMedia({
    color: theme.colors.contentPrimary,
    fontSize: '14px',
    fontWeight: '400',
    width: '150px',
    whiteSpace: 'nowrap',
    overflow: 'hidden',
    textOverflow: 'ellipsis',
    fontFamily: theme.typography.fontFamily.display
  })
);
